import { NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
//import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { throwIfAlreadyLoaded } from '@twino/core-lib/utils';
import {
  CoreLibModule,
  PlatformLanguageToken,
  PlatformWindowToken,
} from '@twino/core-lib';
import { provideNgxMask } from 'ngx-mask';

// bring in custom web services here...

// factories
export function winFactory() {
  return window;
}

export function platformLangFactory() {
  const browserLang = window.navigator.language || 'en'; // fallback English
  // browser language has 2 codes, ex: 'en-US'
  return browserLang.split('-')[0];
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, `./assets/i18n/`, '.json');
}

@NgModule({ exports: [
        CoreLibModule
    ], imports: [BrowserModule,

        CoreLibModule.forRoot([
            {
                provide: PlatformLanguageToken,
                useFactory: platformLangFactory,
            },
            {
                provide: PlatformWindowToken,
                useFactory: winFactory,
            },
        ])], providers: [provideHttpClient(withInterceptorsFromDi()), provideNgxMask()] })
export class TwinoCoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: TwinoCoreModule
  ) {
    throwIfAlreadyLoaded(parentModule, 'TwinoCoreModule');
  }
}
